import { resolveMediaUrl } from '../../lib/mediaUrl';

export function bgToCss(bg) {
  if (!bg) return { background: '#1a1a2e' };
  if (bg.type === 'color') {
    if (bg.overlay) {
      const ov = `rgba(0,0,0,${bg.overlay.opacity ?? 0.3})`;
      return { background: `linear-gradient(${ov}, ${ov}), ${bg.color || '#1a1a2e'}` };
    }
    return { background: bg.color || '#1a1a2e' };
  }
  if (bg.type === 'gradient' && bg.gradient) {
    const { type, direction, stops } = bg.gradient;
    const sorted = [...stops].sort((a, b) => a.position - b.position);
    const stopsStr = sorted.map((s) => `${s.color} ${s.position}%`).join(', ');
    const grad = type === 'linear'
      ? `linear-gradient(${direction}deg, ${stopsStr})`
      : `radial-gradient(circle, ${stopsStr})`;
    return { background: grad };
  }
  if (bg.type === 'image' && bg.mediaSrc) {
    return {
      backgroundImage: `url(${resolveMediaUrl(bg.mediaSrc)})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    };
  }
  return { background: '#1a1a2e' };
}

export function getTemplateFirstPage(template) {
  // Prefer first page that has layers so the preview isn't blank
  const page =
    template.pages?.find(p => (p.layers || []).length > 0) ?? template.pages?.[0];
  if (!page) return { background: undefined, layers: [] };
  const bg = page.background;
  const rawLayers = page.layers || [];
  const layers = rawLayers.map((l, i) => ({
    id: l.id || l._id || `tpl-${template.id}-${i}`,
    pageId: '',
    name: l.name || '',
    locked: false,
    hidden: !!(l.hidden),
    transform: l.transform || { x: 0, y: 0, width: 100, height: 100, rotation: 0, opacity: 1, zIndex: i },
    data: l.data || l,
  }));
  return { background: bg, layers };
}

export const CATEGORY_GRADIENTS = {
  'lifestyle': 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
  'business': 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
  'travel': 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
  'food': 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
  'tech': 'linear-gradient(135deg, #a18cd1 0%, #fbc2eb 100%)',
  'health': 'linear-gradient(135deg, #30cfd0 0%, #330867 100%)',
  'education': 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
  'fashion': 'linear-gradient(135deg, #f6d365 0%, #fda085 100%)',
  'news': 'linear-gradient(135deg, #89f7fe 0%, #66a6ff 100%)',
  'sports': 'linear-gradient(135deg, #ff9a9e 0%, #fecfef 100%)',
  'default': 'linear-gradient(135deg, var(--brand-primary) 0%, #8b5cf6 100%)',
};

export function getCategoryGradient(category) {
  return CATEGORY_GRADIENTS[(category || '').toLowerCase()] || CATEGORY_GRADIENTS['default'];
}

export function formatDate(dateStr) {
  return new Date(dateStr).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export function formatFileSize(bytes) {
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
  return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
}
